import React from 'react';
import { useTheme } from '@mui/material';

export const PaidScreenOutIcon = () => {
    const theme = useTheme();
    const {
        stroke: { primary: primaryStroke },
    } = theme.colors.other.icon;

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={40} height={40} fill="none">
            <path
                fill={primaryStroke}
                d="M15.408 22.348a17.093 17.093 0 0 1-2.292-.193 8.754 8.754 0 0 1-1.313-.32c-.302-.103-.486-.398-.486-.717 0-.603.638-1.021 1.22-.86.202.057.417.111.643.162.757.172 1.5.265 2.228.279v-4.326c-.7-.2-1.314-.414-1.842-.643-.514-.242-.935-.514-1.264-.814a3.075 3.075 0 0 1-.75-1.028 3.728 3.728 0 0 1-.235-1.37c0-.7.164-1.3.493-1.8.342-.499.82-.892 1.435-1.177.614-.3 1.335-.471 2.163-.514v-1.2a.685.685 0 0 1 1.37 0v1.178a8.99 8.99 0 0 1 2.056.257c.334.076.652.162.954.258.431.138.637.613.482 1.038-.164.45-.67.673-1.129.536a11.347 11.347 0 0 0-.692-.182 9.28 9.28 0 0 0-1.67-.279v4.305c.942.271 1.727.564 2.355.878.628.3 1.1.678 1.414 1.135.328.443.492 1.02.492 1.735 0 1-.37 1.813-1.113 2.441-.743.614-1.792.992-3.149 1.135v1.692a.685.685 0 1 1-1.37 0v-1.606Zm1.37-1.756c.843-.086 1.457-.279 1.842-.578a1.48 1.48 0 0 0 .578-1.2c0-.357-.07-.65-.214-.878-.143-.243-.392-.45-.75-.621-.342-.171-.827-.335-1.456-.492v3.769Zm-1.37-9.916c-.514.028-.935.121-1.264.278-.328.143-.578.336-.75.579a1.504 1.504 0 0 0-.235.835c0 .371.064.692.193.964.143.257.378.478.707.663.328.172.778.329 1.349.472v-3.791Z"
            />
            <path
                fill={primaryStroke}
                fillRule="evenodd"
                d="M30.41 3.935a.787.787 0 0 1 1.112 0l5.009 5.009a.787.787 0 0 1-1.113 1.113l-3.665-3.665v9.07c0 8.865-7.186 16.052-16.051 16.052a.787.787 0 1 1 0-1.575c7.995 0 14.477-6.481 14.477-14.476V6.392l-3.665 3.665A.787.787 0 1 1 25.4 8.944l5.01-5.009Z"
                clipRule="evenodd"
            />
        </svg>
    );
};
